import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import GlobalStyle from "./Components/styles/GlobalStyle";
import Home from "./Components/Home/Home";
import Footer from "./Components/Footer/Footer";
import Reservas from "./Components/Reservas/Reservas";
import Header from "./Components/Header/Header";
import Contacto from "./Components/Contacto/Contacto";
import Gracias from "./Components/Gracias/Gracias";
import GraciasContacto from "./Components/GraciasContacto/GraciasContacto";
import ReservaGrupal from "./Components/Grupal/Grupal.js";
import Eventos from "./Components/Eventos/Eventos.js";
import EventDetail from "./Components/Eventos/EventDetail.js";
import QuienesSomos from "./Components/QuienesSomos/QuienesSomos.js"; // ajustá el path si hace falta
import Carta from "./Components/Carta/carta.js"; 
import Experiencias from "./Components/Experiencias/Experiencias.js";
import ExperienceDetail from "./Components/Experiencias/ExperienceDetail.js";
import Voucher from "./Components/Voucher/Voucher.js"
import VoucherRedeem from "./Components/Voucher/VoucherRedeem.js";
import VoucherAdmin from "./Components/Voucher/VoucherAdmin.js";
import WhatsAppButton from "./Components/WhatsAppButton/WhatsAppButton";
import { useTranslation } from "react-i18next";

const siteUrl = "https://eltaller-aguaymanto.com";
const routeSeo = {
  "/contacto": {
    title: "Contacto | El Taller de Aguaymanto",
    description: "Contacta con El Taller de Aguaymanto para resolver dudas o preparar tu experiencia de cerámica en Vilanova del Vallès.",
  },
  "/grupal": {
    title: "Reservas para grupos | El Taller de Aguaymanto",
    description: "Organiza una experiencia de cerámica para grupos en Vilanova del Vallès, cerca de Granollers.",
  },
  "/reservas": {
    title: "Reservar experiencia de cerámica | El Taller de Aguaymanto",
    description: "Reserva tu plaza para una experiencia de cerámica en El Taller de Aguaymanto, Vilanova del Vallès.",
  },
  "/carta": {
    title: "Carta de café | El Taller de Aguaymanto",
    description: "Descubre la carta de café y dulces de El Taller de Aguaymanto en Vilanova del Vallès.",
  },
  "/regala-pinta-tu-ceramica-granollers": {
    title: "Regala una experiencia de cerámica cerca de Granollers | El Taller de Aguaymanto",
    description: "Regala una experiencia creativa de cerámica en Vilanova del Vallès, cerca de Granollers.",
  },
  "/gracias": { title: "Reserva confirmada | El Taller de Aguaymanto", noindex: true },
  "/gracias-contacto": { title: "Mensaje enviado | El Taller de Aguaymanto", noindex: true },
};

const routeSeoCa = {
  "/contacto": { title: "Contacte | El Taller d'Aguaymanto", description: "Contacta amb El Taller d'Aguaymanto per resoldre dubtes o preparar la teva experiència de ceràmica a Vilanova del Vallès." },
  "/grupal": { title: "Reserves per a grups | El Taller d'Aguaymanto", description: "Organitza una experiència de ceràmica per a grups a Vilanova del Vallès, a prop de Granollers." },
  "/reservas": { title: "Reservar una experiència de ceràmica | El Taller d'Aguaymanto", description: "Reserva la teva plaça per a una experiència de ceràmica a El Taller d'Aguaymanto, Vilanova del Vallès." },
  "/carta": { title: "Carta de cafè | El Taller d'Aguaymanto", description: "Descobreix la carta de cafè i dolços d'El Taller d'Aguaymanto a Vilanova del Vallès." },
  "/regala-pinta-tu-ceramica-granollers": { title: "Regala una experiència de ceràmica a prop de Granollers | El Taller d'Aguaymanto", description: "Regala una experiència creativa de ceràmica a Vilanova del Vallès, a prop de Granollers." },
  "/gracias": { title: "Reserva confirmada | El Taller d'Aguaymanto", noindex: true },
  "/gracias-contacto": { title: "Missatge enviat | El Taller d'Aguaymanto", noindex: true },
};

const RouteSeo = () => {
  const { pathname } = useLocation();
  const { i18n } = useTranslation();
  const lang = i18n.language?.startsWith("ca") ? "ca" : "es";
  const seo = (lang === "ca" ? routeSeoCa : routeSeo)[pathname];
  const canonicalUrl = `${siteUrl}${pathname === "/" ? "/" : pathname}`;

  return (
    <Helmet>
      <html lang={lang} />
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:site_name" content="El Taller de Aguaymanto" />
      <meta property="og:url" content={canonicalUrl} />
      {seo?.title && <title>{seo.title}</title>}
      {seo?.description && <meta name="description" content={seo.description} />}
      {seo?.noindex && <meta name="robots" content="noindex, follow" />}
    </Helmet>
  );
};

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      window.requestAnimationFrame(() => {
        document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "smooth", block: "start" });
      });
      return;
    }
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash]);

  return null;
};

const RouteVisitTracker = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const visitorStorageKey = "visitorId";
    let visitorId = localStorage.getItem(visitorStorageKey);

    if (!visitorId) {
      visitorId = `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
      localStorage.setItem(visitorStorageKey, visitorId);
    }

    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    if (!apiBaseUrl) return;

    fetch(`${apiBaseUrl}/api/track-visit`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        path: pathname,
        lang: document.documentElement.lang || "es",
        visitorId,
      }),
    }).catch(() => {
      // Silent fail in frontend; analytics must never block navigation.
    });
  }, [pathname]);

  return null;
};




const App = () => {
  return (
    <>
      <GlobalStyle />
      
     
      <Router>
        <ScrollToTop />
        <RouteVisitTracker />
        <RouteSeo />
        <Header />
      
        
        <Routes>
          <Route path="/" element={<Home />} />
          
          <Route path="/reservas" element={<Reservas />} />
          <Route path="/contacto" element={<Contacto />} />
          <Route path="/gracias" element={<Gracias />} />
          <Route path="/gracias-contacto" element={<GraciasContacto />} />
          <Route path="/grupal" element={<ReservaGrupal />} />
          <Route path="/eventos" element={<Eventos />} />
          <Route path="/team-building-ceramica-vilanova-del-valles" element={<EventDetail slug="team-building-ceramica-vilanova-del-valles" />} />
          <Route path="/cumpleanos-ceramica-vilanova-del-valles" element={<EventDetail slug="cumpleanos-ceramica-vilanova-del-valles" />} />
          <Route path="/taller-privado-ceramica-vilanova-del-valles" element={<EventDetail slug="taller-privado-ceramica-vilanova-del-valles" />} />
          <Route path="/quienes-somos" element={<QuienesSomos />} />
          <Route path="/carta" element={<Carta />} />
          <Route path="/experiencias-ceramica-granollers" element={<Experiencias />} />
          <Route path="/pinta-tu-ceramica" element={<ExperienceDetail id="pinta" />} />
          <Route path="/crea-tu-ceramica-y-decorala" element={<ExperienceDetail id="crea" />} />
          <Route path="/clases-ceramica" element={<ExperienceDetail id="regular" />} />
          <Route path="/ceramica-y-vino" element={<ExperienceDetail id="vino" />} />
          <Route path="/regala-pinta-tu-ceramica-granollers" element={<Voucher/>}/>
          <Route path="/reservar-voucher" element={<VoucherRedeem/>}/>
          <Route path="/admin/vouchers" element={<VoucherAdmin/>}/>
          <Route path="/admin/reservas" element={<VoucherAdmin/>}/>
          
        </Routes>
        <WhatsAppButton />
        <Footer />
      </Router>
    </>
  );
};

export default App;
